import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as React from 'react';

// createRoot is React 18's entry point; this app is on React 17, where render
// is the only one there is. The rule fires anyway, so it is off for this line.
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
